<template>
  <div
    :set="scale(zoom)"
    v-if="label != null && src != null"
    ref="element"
    class="ReportPage"
  >
    <CollectorComponents
      v-for="(child, i) in src._children"
      @resize="label.resize"
      :parentOffset="label.offset"
      :src="child"
      :type="child._tipo"
      :key="i"
    />
  </div>
</template>
<script>
import LabelComponent from "@/classes/LabelComponent.js";

export default {
  name: "ReportPage",
  components: {
    CollectorComponents: () => import("./CollectorComponents.vue"),
  },
  props: {
    src: Object,
    zoom: Number,
  },
  data() {
    return {
      label: null,
    };
  },
  methods: {
    scale(zoom) {
      if (this.$refs.element == null) return;
      this.$refs.element.style.transform = "scale(" + zoom / 100 + ")";
      const that = this;
      setTimeout(() => {
        that.$emit("scaleH", (that.$refs.element.offsetHeight * zoom) / 100);
      }, 100);
      // this.$nextTick(() => {
      //   this.$emit("scaleH", (this.$refs.element.offsetHeight * zoom) / 100);
      // });
    },
  },
  mounted() {
    this.label = new LabelComponent(this);
    if (this.src != null) {
      this.$nextTick(() => {
        const style = {
          width: this.src.Width == null ? "0" : this.src.Width + "mm",
          height: this.src.Height == null ? "0" : this.src.Height + "mm",
          top: this.src.Top == null ? "0" : this.src.Top + "mm",
          left: this.src.Left == null ? "0" : this.src.Left + "mm",
          position: "relative",
          border: "1px solid black",
          boxSizing: "border-box",
          overflow: "hidden",
          // marginBottom:
          //   this.src.bottom_margin === null
          //     ? "0px"
          //     : this.src.bottom_margin + "px",
          // marginLeft:
          //   this.src.left_margin === null ? "0px" : this.src.left_margin + "px",
          // marginRight:
          //   this.src.right_margin === null ? "0px" : this.src.right_margin + "px",
          // marginTop:
          //   this.src.top_margin === null ? "0px" : this.src.top_margin + "px",
        };

        this.label.getStyle(style, { top: 0, left: 0 });
        this.label.rendered = true;
      });
    }
    this.scale(this.zoom);
  },
};
</script>

<style scoped>
.ReportPage {
  transform-origin: 0 0;
  position: relative;
  top: 0;
  left: 0;
}
</style>
